'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.factory('cookieService', function(otppConstants, $cookies, $location) {
  return {
    setLanguageCookie: function(language) {
      const FIVE_HOURS_IN_MS = 1000 * 60 * 60 * 5;
      const datePlusFiveHours = new Date(Date.now() + FIVE_HOURS_IN_MS);

      this.setCookie('language', language, datePlusFiveHours);
    },
    setAuthCallbackDestination: function(destination) {
      const ONE_HOUR_IN_MS = 1000 * 60 * 60;
      const datePlusHour = new Date(Date.now() + ONE_HOUR_IN_MS);
      this.setCookie(otppConstants.authCallbackDestinationKey, destination, datePlusHour);
    },
    setSignupCookie: function(value) {
      const ONE_HOUR_IN_MS = 1000 * 60 * 60;
      const datePlusHour = new Date(Date.now() + ONE_HOUR_IN_MS);
      this.setCookie('signup', value, datePlusHour);
    },
    setCookie: function(key, value, expiry) {
      const domain = $location.host() === 'localhost' ? $location.host() : '.' + $location.host();
      const cookieSettings = {path: '/', expires: expiry, samesite: 'none', secure: true, domain};

      $cookies.put(key, value, cookieSettings);
    },
    removeCookie: function(key){
      const domain = $location.host() === 'localhost' ? $location.host() : '.' + $location.host();
      const cookieSettings = {path: '/', domain};

      $cookies.remove(key, cookieSettings);
    }
  };
});
